// src/pages/Admin/ProgramsView.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ConfirmationModal from '../../components/common/ConfirmationModal';
import PaginatedTable from '../../components/PaginatedTable';
import TitleWithBack from '../../components/common/TitleWithBack';

function ProgramsView() {
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [filter, setFilter] = useState('');
  const [tooltip, setTooltip] = useState('');
  const [deleteId, setDeleteId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPrograms();
  }, []);

  const fetchPrograms = () => {
    setLoading(true);
    axios.get('/api/programs')
      .then(response => {
        const dataArray = Array.isArray(response.data) ? response.data : [];
        const sorted = dataArray.sort((a, b) => b.id - a.id);
        setPrograms(sorted);
        setLoading(false);
      })
      .catch(err => {
        setError('Error fetching programs.');
        setLoading(false);
      });
  };

  const handleDelete = async (programId) => {
    try {
      await axios.delete(`/api/programs/${programId}`);
      setTooltip('Program deleted successfully!');
      fetchPrograms();
      setDeleteId(null);
    } catch (err) {
      setTooltip('Error deleting program.');
    }
  };

  const handleEdit = (programId) => {
    navigate(`/admin/programs/edit/${programId}`);
  };

  const handleExplore = (programId) => {
    navigate(`/admin/programs/explore/${programId}`);
  };

  const filteredPrograms = programs.filter(program =>
    program.name.toLowerCase().includes(filter.toLowerCase()) ||
    program.code.toLowerCase().includes(filter.toLowerCase())
  );

  const columns = [
    { key: 'serial', header: <>#</> },
    { key: 'name', header: <>Name</> },
    { key: 'code', header: <>Code</> },
    { key: 'actions', header: 'Actions' }
  ];

  const renderRow = (program, idx, pageIndex, pageSize) => (
    <>
      <td>{(pageIndex * pageSize) + idx + 1}</td>
      <td>{program.name}</td>
      <td>{program.code}</td>
      <td>
        <button className="btn btn-sm btn-primary me-2" onClick={() => handleEdit(program.id)}>
          Edit
        </button>
        <button className="btn btn-sm btn-danger me-2" onClick={() => setDeleteId(program.id)}>
          Delete
        </button>
        <button className="btn btn-sm btn-secondary" onClick={() => handleExplore(program.id)}>
          Explore
        </button>
      </td>
    </>
  );

  return (
    <div className="container-fluid mt-2 px-4">
      <TitleWithBack title="View All Programs" />
      <div className="mb-3">
        <label className="form-label">Filter:</label>
        <input
          type="text"
          className="form-control"
          placeholder="Search by name or code..."
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        />
      </div>
      {loading ? (
        <p>Loading programs...</p>
      ) : error ? (
        <div className="alert alert-danger">{error}</div>
      ) : filteredPrograms.length === 0 ? (
        <p>Nothing to show here</p>
      ) : (
        <PaginatedTable
          data={filteredPrograms}
          columns={columns}
          renderRow={renderRow}
          rowsPerPage={50}
        />
      )}
      {tooltip && (
        <div className={`mt-3 alert ${tooltip.startsWith('Error') ? 'alert-danger' : 'alert-success'}`}>
          {tooltip}
        </div>
      )}
      {deleteId && (
        <ConfirmationModal 
          title="Confirm Delete"
          message="Are you sure you want to delete this program?"
          onConfirm={() => handleDelete(deleteId)}
          onCancel={() => setDeleteId(null)}
        />
      )}
    </div>
  );
}

export default ProgramsView;
